import { Router } from "@angular/router";

declare let _: any;

export abstract class AbstractTracker {
    abstract readonly ATTR_TRACKER_NAME: string;
    readonly ATTR_ROUTE_PATH_TRACK: string = "pathTrack";

    protected _config: any;
    get trackerName(): string {
        return this.ATTR_TRACKER_NAME;
    };

    /**
     * @whatItDoes Add tracker script to <head> or <body>
     * @param {any} config
     */
    abstract create(config: any);

    /**
     *
     * @param string path
     */
    sendPageView(path: string) {
        setTimeout(() => {
            if(this._hasTrackingId()) {
                this._sendPageView(path);
            }
        }, 50);
    }

    protected abstract _sendPageView(path: string): void;

    /**
     * @whatItDoes Checks if route is trackable.
     *
     * Can set path to track as string:
     * ```
     *
     *      path: 'subscriptions',
     *      data:
     *          googleAnalytics:
     *              pathTrack: '/subscriptions'
     *
     *
     *
     * ```
     *
     * Can set path to track as boolean, it will be take the url from current router:
     * Example: The path is: "/product-page/185"
     * ```
     *
     *     path: 'product-page/:id',
     *     data:
     *         googleAnalytics:
     *             pathTrack: true
     *
     *
     *
     * ```
     * @param Router router
     * @returns string
     */
    isPathTracked(router: Router): string {
        let root = router.routerState.snapshot.root;
        while (root) {
            if (root.children && root.children.length) {
                root = root.children[0];
            } else if (root.data) {
                if(root.data[this.trackerName]) {
                    let tracker = root.data[this.trackerName] || {};
                    let path = tracker[this.ATTR_ROUTE_PATH_TRACK] || null;
                    return path && _.isString(path) ? path : (path === true ? router.url : "");
                }
                return;
            } else {
                return;
            }
        }
        return "";
    }

    protected abstract _appendScripts(whereEl: HTMLElement): void;

    protected _hasTrackingId(): boolean {
        return !_.isEmpty(this._config) && !_.isEmpty(this._config.tracking_id);
    }

}